import { useLayoutEffect, useState, type ReactNode } from 'react'

/**
 * Hydrates fixture state before a real product screen is allowed to render.
 *
 * Preview routes used to call their seed function during render.  Query and
 * Zustand subscribers can synchronously notify the child screen, which React
 * correctly reports as an invalid cross-component update and which can show a
 * transient blank/redirect frame on a cold Android launch.  A layout effect
 * runs after the route commits but before the next visible frame.
 */
export function PreviewSeedBoundary({
  seed,
  seedKey,
  children,
}: {
  seed: () => void
  seedKey: string
  children: ReactNode
}) {
  const [hydratedKey, setHydratedKey] = useState<string | null>(null)

  useLayoutEffect(() => {
    seed()
    setHydratedKey(seedKey)
  }, [seed, seedKey])

  return hydratedKey === seedKey ? <>{children}</> : null
}
